import JobTitleBanner from './JobTitleBanner'

export default JobTitleBanner
